<button type="button" class="btn btn-link modal-close" (click)="cancel()"><svg width="24"
  height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg></button>
<div class="py-3">
  <img *ngIf="status" class="d-block mx-auto" src="../assets/images/delete-close.png" alt=""/>
  <img *ngIf="!status" class="d-block mx-auto info-btn" src="../assets/images/info-icon.png" alt=""/>
  <h3 class="black-text text-center fs-18 font-bold m-b-40 m-t-30">{{message}}</h3>
  <div class="row mx-0 w-100">
    <div class="col-6 ps-0 pe-2">
      <button type="button" class="btn theme-btn-outline w-100" (click)="cancel()">No</button>
    </div>
    <div class="col-6 pe-0 ps-2">
      <button type="button" class="btn theme-btn w-100" (click)="confirm()">Yes</button>
    </div>
  </div>
</div>
